<template>
    <v-app>
        Hola mundo nota fe ampliac
        <CMatSeccionTree />
    </v-app>
</template>
<script>
import gql from 'graphql-tag';
import CMatSeccionTree from '@/components/Academico/MatSeccionTree.vue';

export default {
    name: 'DcbNotaFechaAmpliacion',
    components: {CMatSeccionTree},
}
</script>
